export default __webpack_public_path__ + "static/media/slamBorder.59a38eba.svg";